import { render, staticRenderFns } from "./TaxonomyTagChrome.vue?vue&type=template&id=2ab66991&scoped=true&"
import script from "./TaxonomyTagChrome.vue?vue&type=script&lang=js&"
export * from "./TaxonomyTagChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab66991",
  null
  
)

export default component.exports